import styled from "styled-components";

export const Footer = styled.footer`
  background: #222;
  color: #fff;
  text-align: center;
  padding: 15px;
`;



// WEBPACK FOOTER //
// ./src/components/Footer/style.js